import { render, staticRenderFns } from "./ProspectInfos.vue?vue&type=template&id=dc864e0c&scoped=true&"
import script from "./ProspectInfos.vue?vue&type=script&lang=js&"
export * from "./ProspectInfos.vue?vue&type=script&lang=js&"
import style0 from "./ProspectInfos.vue?vue&type=style&index=0&id=dc864e0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc864e0c",
  null
  
)

export default component.exports